export default __webpack_public_path__ + "static/media/client-22.f55487f2.webp";